<template>
  <div
  class="Authenticated"
  v-loading="busy"
  element-loading-spinner="Authenticated__loader">
    <SideMenu
    v-if="user"
    class="Authenticated__menu"/>
    <div
    v-if="user"
    class="Authenticated__content">
      <NavBar/>
      <transition
      name="from-right-to-left"
      mode="out-in">
        <router-view/>
      </transition>
    </div>
    <div
    v-else
    class="Authenticated__loader"/>
    <ModalPreview/>
    <ModalMove/>
    <ModalRename/>
    <ModalShare/>
    <ModalShareKc/>
    <Transfer/>
    <vue-progress-bar/>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import UserMixin from '@/components/mixins/User.mixin'

import Transfer from '@/components/globals/transfer/Transfer'
import ModalMove from '@/components/modal/move/ModalMove'
import ModalPreview from '@/components/modal/preview/ModalPreview'
import ModalRename from '@/components/modal/rename/ModalRename'
import ModalShare from '@/components/modal/share/ModalShare'
import ModalShareKc from '@/components/modal/share-kc/ModalShareKc'
import NavBar from '@/components/globals/nav-bar/NavBar'
import SideMenu from '@/components/globals/side-menu/SideMenu'

export default {
  name: 'Authenticated',

  mixins: [
    UserMixin
  ],

  components: {
    Transfer,
    ModalMove,
    ModalPreview,
    ModalRename,
    ModalShare,
    ModalShareKc,
    NavBar,
    SideMenu
  },

  computed: {
    ...mapGetters('busy', [
      'busy'
    ])
  },

  mounted () {
    if (Vue.prototype.$cookie.get('accessToken')) {
      this.getCurrentUser()
    }
    this.getCloudStorage()
    this.getUserContacts()
  },

  methods: {
    ...mapActions('user', [
      'getCurrentUser',
      'getCloudStorage',
      'getUserContacts'
    ])
  }
}
</script>

<style lang="scss">
@import 'Authenticated';
</style>
